import { render, staticRenderFns } from "./newItem.vue?vue&type=template&id=40dd1845&"
import script from "./newItem.vue?vue&type=script&lang=js&"
export * from "./newItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports